// @vue/component
import {useStrategyDetailsStore} from "@/stores/CrossWalkAnalysis/strategyDetails";
import {storeToRefs} from "pinia";
import { MDBBtn, MDBIcon, MDBTooltip } from 'mdb-vue-ui-kit';
import {useCrosswalkChallengeStore} from "@/stores/CrossWalkAnalysis/challenge";

export default {
  name: 'StrategySetup',

  components: {MDBBtn, MDBIcon, MDBTooltip},

  mixins: [],

  props: {},

  setup() {
    const strategyDetailsStore = useStrategyDetailsStore()
    const challengeStore = useCrosswalkChallengeStore()
    const { editMode } =  storeToRefs(challengeStore)
    const { matrixType } =  storeToRefs(strategyDetailsStore)
    const { goalNumber } =  storeToRefs(strategyDetailsStore)

    return { strategyDetailsStore, matrixType, goalNumber, editMode}

  },

  data () {
    return {
    }
  },

  computed: {
    goals() {
      return this.$tm("criticalGoals.goals") || [];
    }
  },

  watch: {
    matrixType: {
      handler() {
        this.strategyDetailsStore.matrixTypeChanged()
      }
    },
    goalNumber: {
      handler() {
        this.strategyDetailsStore.goalNumberChanged()
      }
    },
  },

  mounted () {
    this.strategyDetailsStore.fetchCrosswalkAnalysis()
    this.strategyDetailsStore.showNext = false
    if (this.goalNumber === null || this.goalNumber === undefined || this.goalNumber === "") {
      this.strategyDetailsStore.goalNumber = 1
    }
  },

  methods: {}
}
